import facebook from '../../Content/Images/facebook.png';
import twitter from '../../Content/Images/twitter2.png';
import linkedin from '../../Content/Images/linkedin.png';
import email from '../../Content/Images/email1.png';
import location from '../../Content/Images/location.png';
import whatsapp from '../../Content/Images/whatsapp.png';

function SocialMediaLinks() {
    return (
        <div className="sm-link-container">
            <div className="sm-link fb-link">
                <img className='sm-link-img' src={facebook} alt="fb" />
                <span className='sm-link-text'>Facebook</span>
            </div>
            <div className="sm-link x-link">
                <img className='sm-link-img' src={twitter} alt="tweet" />
                <span className='sm-link-text'>X</span>
            </div>
            <div className="sm-link linkedin-link">
                <img className='sm-link-img' src={linkedin} alt="linkedin" />
                <span className='sm-link-text'>LinkedIn</span>
            </div>
            <div className="sm-link whatsapp-link">
                <img className='sm-link-img' src={whatsapp} alt="map" />
                <span className='sm-link-text'>Whatsapp</span>
            </div>
            <div className="sm-link email-link">
                <img className='sm-link-img' src={email} alt="email" />
                <span className='sm-link-text'>Email</span>
            </div>
            <div className="sm-link map-link">
                <img className='sm-link-img' src={location} alt="map" />
                <span className='sm-link-text'>Location</span>
            </div>
        </div>
    );
}

export default SocialMediaLinks;
